import React, { useState } from 'react';
import { authFetch } from '../../utils/api'; // ✅ make sure authFetch handles headers and JSON

function Stage1Form({ userEmail, onScrapeSuccess }) {
  const [form, setForm] = useState({
    category: '',
    country: '',
    hashtag: '',
    minFollowers: '',
    maxFollowers: '',
    numberOfLeads: 10,
  });

  const [loading, setLoading] = useState(false);
  const [resultMsg, setResultMsg] = useState('');
  const [showModal, setShowModal] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation: hashtag required
    if (!form.hashtag.trim()) {
      setResultMsg('Please enter a hashtag.');
      setShowModal(true);
      return;
    }

    setLoading(true);
    setShowModal(false);
    setResultMsg('');

    try {
      const payload = {
        ...form,
        currentUserEmail: userEmail,
        numberOfLeads: Number(form.numberOfLeads),
        minFollowers: Number(form.minFollowers),
        maxFollowers: Number(form.maxFollowers),
      };

      const result = await authFetch('/scrape', {
        method: 'POST',
        body: JSON.stringify(payload),
      });

      const newLeads = result.newLeadsFoundInThisRun || 0;
      setResultMsg(`Scraping done. ${newLeads} new leads saved.`);
      setShowModal(true);
      onScrapeSuccess?.();
    } catch (error) {
      setResultMsg(error.message || 'Error occurred during scraping.');
      setShowModal(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="form-wrapper" style={{ position: 'relative' }}>
      {loading && (
        <div className="loader-overlay">
          <div className="loader">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
          </div>
          <p className="loader-text">Scraping Leads...</p>
        </div>
      )}

      {showModal && (
        <div className="modal-overlay">
          <div className="modal-box">
            <p>{resultMsg}</p>
            <button className="close-btn" onClick={() => setShowModal(false)}>OK</button>
          </div>
        </div>
      )}

      <form onSubmit={handleSubmit} className="scrape-form">
        <h2 className="form-title">Stage 1: Leads Scraper</h2>
        <div className="form-grid">
          <div className="form-group">
            <label htmlFor="category">Category</label>
            <input
              id="category"
              name="category"
              value={form.category}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label htmlFor="country">Country</label>
            <input
              id="country"
              name="country"
              value={form.country}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label htmlFor="hashtag">Hashtag</label>
            <input
              id="hashtag"
              name="hashtag"
              value={form.hashtag}
              onChange={handleChange}
              placeholder="#example"
            />
          </div>
          <div className="form-group">
            <label htmlFor="numberOfLeads">No. of Leads</label>
            <input
              id="numberOfLeads"
              name="numberOfLeads"
              type="number"
              value={form.numberOfLeads}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label htmlFor="minFollowers">Min Followers</label>
            <input
              id="minFollowers"
              name="minFollowers"
              type="number"
              value={form.minFollowers}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label htmlFor="maxFollowers">Max Followers</label>
            <input
              id="maxFollowers"
              name="maxFollowers"
              type="number"
              value={form.maxFollowers}
              onChange={handleChange}
            />
          </div>
        </div>

        <button type="submit" className="submit-btn" disabled={loading}>
          {loading ? 'Scraping...' : 'Start Scraping'}
        </button>
      </form>
    </div>
  );
}

export default Stage1Form;
